import { render, staticRenderFns } from "./gongshi.vue?vue&type=template&id=89a83bcc&scoped=true&"
import script from "./gongshi.vue?vue&type=script&lang=js&"
export * from "./gongshi.vue?vue&type=script&lang=js&"
import style0 from "./gongshi.vue?vue&type=style&index=0&id=89a83bcc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a83bcc",
  null
  
)

export default component.exports